// extracted by mini-css-extract-plugin
export default {"compliance":"Compliance_compliance__fXifM","complianceText":"Compliance_complianceText__7Wd3x"};